import { createSelector } from 'reselect';

const returnUrl = authConfig => authConfig.returnUrl;

export default createSelector(state => state.authConfig, returnUrl);
